<template>
  <el-dialog :center="true" :close-on-click-modal="false" title="用户角色配置" :visible.sync="userShow" width="40%"
    @close="closeEditDialog">
    <el-form label-width="80px">
      <el-form-item label="用户名">
        <el-input disabled :value="sysUser.username"></el-input>
      </el-form-item>
      <el-form-item label="角色列表">
        <el-radio-group v-model="sysUser.roleId">
          <el-radio v-for="item in roleList" :key="item.poId" :label="item.poId">{{ item.poName }}</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeEditDialog">取消</el-button>
      <el-button type="primary" @click="saveEditForm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>

import axios from "axios";
import apiBaseUrl from "../../../config/api";

export default {
  components: {},
  data () {
    return {
      roleList: [],
      userShow: false, // 是否全选
      allRoles: [], // 所有角色列表
      sysUser: {
        username: '',
        roleId: '',
        userId: '',
      }
    };
  },
  computed: {},
  watch: {},
  methods: {
    //查询权限
    listData () {
      const data = {
        po_id: '0',
        jur_title: '',
      }
      axios
        .post(
          `${apiBaseUrl}/admin/postlist`,
          data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }
        )
        .then(response => {
          this.roleList = response.data.data.list;
        })
        .catch(error => {
          console.log(error);
        });
    },
    showUser (user) {
      this.sysUser.userId = user.id
      this.userShow = true
      this.sysUser.username = user.realname
      const data = {
        user_id: user.id,
        poName: ''
      }
      axios
        .post(
          `${apiBaseUrl}/admin/postlist`,
          data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }
        )
        .then(response => {
          this.sysUser.roleId = response.data.data.list[0].poId;
        })
        .catch(error => {
          console.log(error);
          
        });
      this.sysUser.roleId = ''
    },
    //取消按钮
    closeEditDialog () {
      this.userShow = false
    },
    //确定按钮
    saveEditForm () {
      const data = {
        user_id: this.sysUser.userId,
        po_id: this.sysUser.roleId,
      }
      axios
        .post(
          `${apiBaseUrl}/admin/useraddpost`,
          data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }
        )
        .then(response => {
          if (response.data.code === 200) {
            this.$message({
              message: '角色设置成功',
              type: 'success'
            })
            this.userShow = false
          } else {
            this.$message({
              message: '操作失败',
              type: 'error'
            })
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },

  created () {

  },
  mounted () {
    this.listData()
  },

}


</script>

<style scoped></style>




// WEBPACK FOOTER //
// src/manager/components/UserSetRole.vue